<script setup lang="ts">
import {pluralize} from "@/core/filters/Pluralize";
import Icon from "@/core/components/icon/Icon.vue";

defineProps<{
    count: number;
}>();
</script>

<template>
  <router-link :to="{name: 'patient-administration.application.certified-customers'}">
    <div class="bg-white rounded-lg p-4 w-full">
      <div class="flex items-center justify-between gap-4 h-full">
        <div class="space-y-1">
          <p class="font-bold">
            {{ count }} {{ pluralize("patient", count) }} {{ pluralize("équipé", count) }}
          </p>
          <p v-if="count">
            Félicitations 👏
          </p>
        </div>
        <Icon name="mdi-chevron-right" :size="30" class="self-center" />
      </div>
    </div>
  </router-link>
</template>

<style scoped>

</style>
